/**
 * [API] 유저 정보
 * @module @apis/user
 */

import axios from '@/user/apis/common/axios-handle-error.service'

/**
 * 현재 사용자 조회
 * @method current
 * @returns {promise} {data} 사용자 id 정보
 */
const current = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/user/v1/current'
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 현재 사용자가 속한 파트너 조직 목록 조회
 * @method orgs
 * @returns {promise} {data} 맴버가 속한 조직
 */
const orgs = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/user/v1/orgs'
    return axios
      .get(url)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 현재 사용자가 소유한 파트너 조직 조회
 * @method ownedOrg
 * @returns {promise} {data} 맴버가 소유한 조직
 */
const ownedOrg = () => {
  return new Promise((resolve, reject) => {
    const url = '/api/user/v1/owned-org'
    return axios
      .get(url)
      .then(({ data }) => resolve(data || null))
      .catch(reject)
  })
}

export const UserService = {
  current,
  orgs,
  ownedOrg,
}
